// src/services/adminOnboardingService.ts

import apiClient from './apiClient';
import {
  OnboardingListResponse,
  OnboardingDetailsResponse,
  OnboardingStatsResponse
} from '../types/onboarding';

interface OnboardingFilters {
  page?: number;
  limit?: number;
  status?: string;
  adminReviewStatus?: string;
  search?: string;
  sortBy?: string;
  sortOrder?: string;
}

class AdminOnboardingService {
  /**
   * Get all drivers in onboarding
   */
  async getOnboardingList(filters: OnboardingFilters = {}): Promise<OnboardingListResponse> {
    const params = new URLSearchParams();
    
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    if (filters.status) params.append('status', filters.status);
    if (filters.adminReviewStatus) params.append('adminReviewStatus', filters.adminReviewStatus);
    if (filters.search) params.append('search', filters.search);
    if (filters.sortBy) params.append('sortBy', filters.sortBy);
    if (filters.sortOrder) params.append('sortOrder', filters.sortOrder);

    const response = await apiClient.get(`/admin/onboarding?${params.toString()}`);
    return response.data;
  }

  /**
   * Get detailed onboarding for specific driver
   */
  async getOnboardingDetails(userId: string): Promise<OnboardingDetailsResponse> {
    const response = await apiClient.get(`/admin/onboarding/${userId}`);
    return response.data;
  }

  /**
   * Get onboarding statistics
   */
  async getOnboardingStats(): Promise<OnboardingStatsResponse> {
    const response = await apiClient.get('/admin/onboarding/stats');
    return response.data;
  }

  /**
   * Approve a specific step
   */
  async approveStep(userId: string, stepName: string, notes?: string) {
    const response = await apiClient.post(`/admin/onboarding/${userId}/approve-step`, {
      stepName,
      notes
    });
    return response.data;
  }

  /**
   * Reject a specific step
   */
  async rejectStep(userId: string, stepName: string, reason: string, notes?: string) {
    const response = await apiClient.post(`/admin/onboarding/${userId}/reject-step`, {
      stepName,
      reason,
      notes
    });
    return response.data;
  }

  /**
   * Approve entire onboarding
   */
  async approveOnboarding(userId: string, notes?: string) {
    const response = await apiClient.post(`/admin/onboarding/${userId}/approve`, {
      notes
    });
    return response.data;
  }

  /**
   * Reject entire onboarding
   */
  async rejectOnboarding(userId: string, reason: string, notes?: string) {
    const response = await apiClient.post(`/admin/onboarding/${userId}/reject`, {
      reason,
      notes
    });
    return response.data;
  }

  /**
   * Add admin comment
   */
  async addComment(userId: string, comment: string) {
    const response = await apiClient.post(`/admin/onboarding/${userId}/comment`, {
      comment
    });
    return response.data;
  }
}

export default new AdminOnboardingService();